import { SwimlaneItem } from '@rikstv/play-common/src/forces/assetDetails/assetDetails.types';

export const placeholderSwimlaneItem: SwimlaneItem = {
  id: 'placeholder-item-id',
  cardId: 'placeholder-card-id',
  title: 'Placeholder Title',
  subtitle: 'Placeholder Subtitle',
  channel: {
    id: 1,
    logo: '',
    name: 'Placeholder Channel',
  },
  image: {
    url: '',
    bwFilter: false,
  },
  description: '',
  imdbRating: '8.1',
  ageLimit: undefined,
  programState: {
    type: 'Default',
  },
  behaviors: [
    {
      from: '0001-01-01T00:00:00Z',
      to: '9999-12-31T23:59:59.9999999Z',
      target: 'OpenSuperCoverPage',
    },
  ],
  logos: [
    {
      name: 'Fallback Channel',
      logo: 'https://static.rikstv.no/logopack/SkyShowtime_square.svg',
    },
  ],
  userData: undefined,
  links: {
    myList: {
      href: '',
    },
    superCoverPage: {
      type: 'Series',
      href: '',
      id: '',
    },
    details: {
      href: '',
      id: '',
    },
  },
  tracking: {
    id: 'placeholder-item-id',
    title: 'Placeholder Title',
    seriesId: 'placeholder-series-id',
  },
};
